import { designTokens } from "@itandi/itandi-bb-ui";
import { Alertv2 } from "@itandi/itandi-bb-ui/Alertv2";
import { Buttonv2 } from "@itandi/itandi-bb-ui/Buttonv2";
import { Grid } from "@itandi/itandi-bb-ui/Grid";
import { Label } from "@itandi/itandi-bb-ui/Label";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import { Paragraph } from "@itandi/itandi-bb-ui/Paragraph";
import { Spinner } from "@itandi/itandi-bb-ui/Spinner";
import { useRouter } from "next/router";
import { useState } from "react";

type Props = {
	backToEditPath: string;
};

export function ProcessingState({ backToEditPath }: Props) {
	const router = useRouter();
	const [isLeaveConfirmModalOpen, setIsLeaveConfirmModalOpen] = useState(false);

	return (
		<Grid
			gap={designTokens["spacing/l"]}
			justifyItems="center"
			maxWidth="480px"
			mt={designTokens["spacing/6xl"]}
			mx="auto"
		>
			<Grid gap={designTokens["spacing/s"]} justifyItems="center">
				<Spinner size="l" />
				<Grid gap={designTokens["spacing/xs"]} justifyItems="center">
					<Label size="l" weight="bold">
						見積書をAIで読み取っています
					</Label>
					<Paragraph textAlign="center">
						AIがPDFを解析し、施工項目や金額を抽出しています。
						<br />
						通常30秒程度で完了します。処理状況により、最大3分程度かかります。
					</Paragraph>
				</Grid>
			</Grid>
			<Buttonv2
				onClick={() => {
					setIsLeaveConfirmModalOpen(true);
				}}
				variant="secondary"
			>
				見積作成画面へもどる
			</Buttonv2>
			<Modalv2
				isOpen={isLeaveConfirmModalOpen}
				onClose={() => {
					setIsLeaveConfirmModalOpen(false);
				}}
				size="s"
			>
				<ModalHeader title="見積作成画面へもどる" />
				<ModalBody>
					<Paragraph>見積作成画面へもどります。</Paragraph>
					<Alertv2 mt={designTokens["spacing/s"]} variant="warning">
						今回の処理結果にもどることはできません。
					</Alertv2>
				</ModalBody>
				<ModalFooter
					leftArea={
						<Buttonv2
							onClick={() => {
								setIsLeaveConfirmModalOpen(false);
							}}
							variant="secondary"
						>
							キャンセル
						</Buttonv2>
					}
					rightArea={
						<Buttonv2
							onClick={() => {
								void router.push(backToEditPath);
							}}
							variant="primary"
						>
							見積作成画面へもどる
						</Buttonv2>
					}
				/>
			</Modalv2>
		</Grid>
	);
}
